import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DialpadService {
  keypadRows = [
    [{ number: 1, letters: '' }, { number: 2, letters: 'ABC' }, { number: 3, letters: 'DEF' }],
    [{ number: 4, letters: 'GHI' }, { number: 5, letters: 'JKL' }, { number: 6, letters: 'MNO' }],
    [{ number: 7, letters: 'PQRS' }, { number: 8, letters: 'TUV' }, { number: 9, letters: 'WXYZ' }],
    [{ number: 0, letters: '+' }],
  ];

  appendToPhoneNumber(phoneNumber: string, digit: number): string {
    return phoneNumber + digit;
  }
}